<template>
  <va-edit-layout :title="title">
    <faqs-form :id="id" :item="item"></faqs-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
